export enum EventType {
  ALERT_CLEARED = 'ALERT_CLEARED',
  ALERT_SETTING_CHANGED = 'ALERT_SETTING_CHANGED',
  ASSESSMENT_COMPLETED = 'ASSESSMENT_COMPLETED',
  CAREGIVER_ADDED = 'CAREGIVER_ADDED',
  CONSENT_ADDED = 'CONSENT_ADDED',
  CONSENT_DOCUMENT_DELETED = 'CONSENT_DOCUMENT_DELETED',
  CONSENT_DOCUMENT_UPLOADED = 'CONSENT_DOCUMENT_UPLOADED',
  CONSENT_UPDATED = 'CONSENT_UPDATED',
  CURATOR_CHANGED = 'CURATOR_CHANGED',
  DEVICE_CONNECTION_ADDED = 'DEVICE_CONNECTION_ADDED',
  DEVICE_CONNECTION_REMOVED = 'DEVICE_CONNECTION_REMOVED',
  // DISCERN_RECORD_MERGED = 'DISCERN_RECORD_MERGED',
  EMR_CONNECTION_ADDED = 'EMR_CONNECTION_ADDED',
  EMR_CONNECTION_REMOVED = 'EMR_CONNECTION_REMOVED',
  EMR_RECORD_UPLOADED = 'EMR_RECORD_UPLOADED',
  FAMILY_HISTORY_ADDED = 'FAMILY_HISTORY_ADDED',
  HEALTH_NETWORK_RECORD_UPLOADED = 'HEALTH_NETWORK_RECORD_UPLOADED',
  IMMUNIZATION_ADDED = 'IMMUNIZATION_ADDED',
  INIT_DEVICE_CONNECTION_ADDED = 'INIT_DEVICE_CONNECTION_ADDED',
  INIT_DEVICE_CONNECTION_REMOVED = 'INIT_DEVICE_CONNECTION_REMOVED',
  LEGAL_DIRECTIVES_UPDATED = 'LEGAL_DIRECTIVES_UPDATED',
  MEDICATION_ADDED = 'MEDICATION_ADDED',
  PATIENT_CREATED = 'PATIENT_CREATED',
  PATIENT_RECORD_UPLOADED = 'PATIENT_RECORD_UPLOADED',
  PRACTITIONER_CHANGED = 'PRACTITIONER_CHANGED',
  RECORD_EDITED = 'RECORD_EDITED',
  SETUP_INVITATION_SENT = 'SETUP_INVITATION_SENT',
  UPCOMING_APPOINTMENT_ADDED = 'UPCOMING_APPOINTMENT_ADDED',
  USER_ACCESSED_PATIENT = 'USER_ACCESSED_PATIENT',
  USER_DISABLED = 'USER_DISABLED',
  USER_NAME_CHANGED = 'USER_NAME_CHANGED',
  USER_PASSWORD_RESET = 'USER_PASSWORD_RESET',
  USER_REENABLED = 'USER_REENABLED',
  USER_STATUS_CHANGED = 'USER_STATUS_CHANGED',
}

export enum EventFriendlyText {
  ALERT_CLEARED = 'Alert Cleared',
  ALERT_SETTING_CHANGED = 'Alert Setting Changed',
  ASSESSMENT_COMPLETED = 'Assessment Completed',
  CAREGIVER_ADDED = 'Caregiver Added',
  CONSENT_ADDED = 'Consent Added',
  CONSENT_DOCUMENT_DELETED = 'Consent Document Deleted',
  CONSENT_DOCUMENT_UPLOADED = 'Consent Document Uploaded',
  CONSENT_UPDATED = 'Consent Updated',
  CURATOR_CHANGED = 'Curator Changed',
  DEVICE_CONNECTION_ADDED = 'Device Connection Added',
  DEVICE_CONNECTION_REMOVED = 'Device Connection Removed',
  DISCERN_RECORD_MERGED = 'Discern Record Merged',
  EMR_CONNECTION_ADDED = 'EMR Connection Added',
  EMR_CONNECTION_REMOVED = 'EMR Connection Removed',
  EMR_RECORD_UPLOADED = 'EMR Record Uploaded',
  FAMILY_HISTORY_ADDED = 'Family History Added',
  HEALTH_NETWORK_RECORD_UPLOADED = 'Health Network Record Uploaded',
  IMMUNIZATION_ADDED = 'Immunization Added',
  INIT_DEVICE_CONNECTION_ADDED = 'Started Device Connection',
  INIT_DEVICE_CONNECTION_REMOVED = 'Started Device Disconnection',
  LEGAL_DIRECTIVES_UPDATED = 'Legal Directives Updated',
  MEDICATION_ADDED = 'Medication Added',
  PATIENT_CREATED = 'Patient Created',
  PATIENT_RECORD_UPLOADED = 'Patient Record Uploaded',
  PRACTITIONER_CHANGED = 'Practitioner Changed',
  RECORD_EDITED = 'Record Edited',
  SETUP_INVITATION_SENT = 'Setup Invitation Sent',
  UPCOMING_APPOINTMENT_ADDED = 'Upcoming Appointment Added',
  USER_ACCESSED_PATIENT = 'User Accessed Patient',
  USER_DISABLED = 'User Disabled',
  USER_NAME_CHANGED = 'User Name Changed',
  USER_PASSWORD_RESET = 'User Password Reset',
  USER_REENABLED = 'User Reenabled',
  USER_STATUS_CHANGED = 'User Status Changed',
}
